export default "__VITE_ASSET__BEvFdcz4__"